import {
  takeEvery, put, call, select,
} from 'redux-saga/effects';
import { ActionTypes } from 'src/store/requests/app/actions';
import { requestSelectors } from 'src/store/requests/selectors';
import { getDefaultPlacementType } from 'src/store/crosstable/selectors';
import { getBuildType } from 'src/helpers';
import { BuildEnv } from 'src/typings/env';
import { getPlacementTypesByComplex } from 'src/api';
import { IPlacementType } from 'src/store/type-displayed-spinner/types';
import { IFrontConfigTypeEnum } from 'src/typings/table';
import { queryClient } from 'src/lib/queryClient';
import { QUERY_KEYS } from 'src/constants/queryKeys';
import { resolveCrosstableFloorType } from 'src/helpers/crosstableSubView';
import { getEnabledViewsBySortOrder } from './helpers';
import { Actions } from './actions';
import { Actions as View2dActions } from '../view-2d/actions';
import { getComplexId, getCurrentLang } from '../app/selectors';

export function* setTypeDisplayedParams() {
  const complexId: number | null = yield select(getComplexId);
  const { data } = yield call(getPlacementTypesByComplex);

  queryClient.setQueryData([QUERY_KEYS.PLACEMENT_TYPES, complexId], data['hydra:member']);

  const buildType = getBuildType();
  const isCrossTable = buildType === BuildEnv.crossTable;
  const currentLang: string = yield select(getCurrentLang);
  const defaultLang: string | undefined = yield select(requestSelectors.app.getLang);
  const activeLang = currentLang || defaultLang;
  const defaultPlacementType: string | null = yield select(getDefaultPlacementType);

  yield put(Actions.setListTypesSuccess(data['hydra:member']));
  if (defaultPlacementType) {
    const displaySpinnerType: IPlacementType | undefined = activeLang
      ? data['hydra:member'].find((type: IPlacementType) => type.title[activeLang] === defaultPlacementType)
      : undefined;
    if (!displaySpinnerType) {
      return;
    }
    const { views } = displaySpinnerType.frontConfig[isCrossTable ? IFrontConfigTypeEnum.adminPanel : IFrontConfigTypeEnum.website];
    const enabledViews = getEnabledViewsBySortOrder(views);
    const configuredFloorType = resolveCrosstableFloorType(views);
    if (configuredFloorType) {
      yield put(View2dActions.setFloorItemType(configuredFloorType));
    }
    if (enabledViews[0]) {
      yield put(Actions.setTypeDisplayedSpinner(enabledViews[0].type));
    }
  } else {
    const foundedType: IPlacementType = data['hydra:member'].find((item: IPlacementType) => {
      return !!item.frontConfig[isCrossTable ? IFrontConfigTypeEnum.adminPanel : IFrontConfigTypeEnum.website].views.length;
    });
    if (foundedType) {
      const { views } = foundedType.frontConfig[isCrossTable ? IFrontConfigTypeEnum.adminPanel : IFrontConfigTypeEnum.website];
      const enabledViews = getEnabledViewsBySortOrder(views);
      const configuredFloorType = resolveCrosstableFloorType(views);
      if (configuredFloorType) {
        yield put(View2dActions.setFloorItemType(configuredFloorType));
      }
      if (enabledViews[0]) {
        yield put(Actions.setTypeDisplayedSpinner(enabledViews[0].type));
      }
    }
  }
}

export function* getTypeDisplayedWatchSaga() {
  yield takeEvery(ActionTypes.GET_APP_DATA_REQUEST_SUCCESS, setTypeDisplayedParams);
}
